/* eslint-disable no-unused-expressions */
import * as marietta from '../..';
import {
  CONTROL_ACTIONMODE, ITEM_MODE_NO, SITE_EDITMODE,
} from '../Constants';
import { SVGSprite } from '../flash/display';
import { SnapElemnt } from '../manager/SnapManager';
import { Stage } from '../model';

class ItemControllerBasePointInput {
  dotList: marietta.core.Point[] = [];

  childSiteList: marietta.webcad.item.Site[] = [];

  lineList: marietta.webcad.item.parts.SiteLine[] = [];

  callbackOnComplete: Function;

  callbackOnInterrupt: Function;

  x: number;

  y: number;

  lastTime: number;

  currentLine: marietta.webcad.control.parts.StrechLine;

  currentText: marietta.webcad.control.parts.StrechLineText | marietta.webcad.control.parts.StretchLineWallText;

  closestLine: marietta.webcad.item.parts.SiteLine;

  type: string;

  floor: number;

  tarLayer: marietta.webcad.layer.FloorShitaeLayer;

  public spt: SVGSprite;

  public dotImage: SVGSprite;

  moveMouseEvent: MouseEvent & TouchEvent;

  isSelectBaseEvent: boolean = false;

  mousePlace: marietta.core.Point;

  // mousePlace が吸着要素の上にあるか。null は追従側で吸着判定をしていない（屋根など）ことを表す
  protected isMousePlaceSnapped: boolean|null = null;

  snapList: SnapElemnt[];

  isPointOnWall: Function;

  updateLineByTextInput: Function;

  isRoomWallSnap: boolean = false;

  hasRoomWallSnap: boolean = true;

  public isBtnInputCompleted: boolean = false;

  /**
   * コンストラクタ
   */
  constructor() {
    this.floor = marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor;
    this.tarLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(this.floor, true) as marietta.webcad.layer.FloorShitaeLayer;

    // ドットイメージの作成
    const _dotImage: Element = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    _dotImage.setAttribute('id', 'dotImage');
    this.tarLayer.viewObj.appendChild(_dotImage);
    this.dotImage = new SVGSprite(_dotImage);

    // ペンの生成
    const targetItem = document.getElementById('lib_icon_pen');
    const viewObj = <SVGElement>targetItem.querySelector('svg > g').cloneNode(true);
    viewObj.setAttribute('id', 'controller_pen');

    this.tarLayer.viewObj.appendChild(viewObj);
    this.spt = new SVGSprite(viewObj);

    const stage = document.querySelector('#layerGroup');
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode === CONTROL_ACTIONMODE.ACTIONMODE_INPUT_POINT_SITE) {
      stage.addEventListener('contextmenu', ItemControllerBasePointInput.contextMenu);
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentSiteEditMode === SITE_EDITMODE.SITE_EDIT_TRIANGULAR_INPUT) {
        this.initAllItemList();
      }
    }

    if (ua.isMobile || ua.isTablet) {
      stage.addEventListener('touchmove', this.followMouse, { passive: false });
      if ((marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode === CONTROL_ACTIONMODE.ACTIONMODE_INPUT_POINT_SITE) && (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentSiteEditMode === SITE_EDITMODE.SITE_EDIT_TRIANGULAR_INPUT) && (this.childSiteList && this.childSiteList.length > 0)) {
        this.isSelectBaseEvent = true;
        stage.addEventListener('touchstart', this.onClickBase, { passive: false });
      } else {
        stage.addEventListener('touchstart', this.onMouseDown, { passive: false });
      }
      // stage.addEventListener("touchstart", this.onMouseDown, { passive: false });
    } else {
      stage.addEventListener('mousemove', this.followMouse);
      if ((marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode === CONTROL_ACTIONMODE.ACTIONMODE_INPUT_POINT_SITE) && (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentSiteEditMode === SITE_EDITMODE.SITE_EDIT_TRIANGULAR_INPUT) && (this.childSiteList && this.childSiteList.length > 0)) {
        this.isSelectBaseEvent = true;
        stage.addEventListener('mousedown', this.onClickBase);
      } else {
        stage.addEventListener('mousedown', this.onMouseDown);
      }
    }

    this.isBtnInputCompleted = false;
    // 入力完了ボタンの追加
    this.addInputCompleted();

    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.isSnap() === false) {
      this.snapList = [];
      this.snapList = marietta.webcad.WebCADGlobal.snapManager.snapElements.map((m: SnapElemnt) => m);
      marietta.webcad.WebCADGlobal.snapManager.createSnapGuide(this.tarLayer);
    }

    const scope: ItemControllerBasePointInput = this;

    // comment k.kubonaka
    // mousemoveハンドラのタイミングで描画処理を行うとIEで極端にFPS低下するため
    // 実際の描画処理は、SpriteのEnterFrame(setTimeOut)ベースで行う
    this.spt.onEnterFrame = (): void => {
      if (scope.moveMouseEvent != null) {
        if (scope.isSelectBaseEvent) {
          scope.followMouseToClickBase();
        } else {
          scope.followMouseHandler();
        }
      }
    };

    // ピッカーの大きさの調整
    this.updatePickers();
  }

  static contextMenu(e: MouseEvent) {
    e.preventDefault();
  }

  initAllItemList() {
    const tarLayer: marietta.webcad.layer.SiteLayer = marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(1, ITEM_MODE_NO.MODE_SITE_NO) as marietta.webcad.layer.SiteLayer;
    const items = tarLayer.getAllChildren();
    for (let i = 0; i < items.length; i += 1) {
      this.childSiteList.push(items[i] as marietta.webcad.item.Site);
    }
  }

  followMouseToClickBase() {
    const newPoint: marietta.core.Point = new marietta.core.Point(this.tarLayer.spt.mouseX, this.tarLayer.spt.mouseY);
    const snapUnit: number = 1;
    this.spt.x = Math.round(newPoint.x / snapUnit) * snapUnit;
    this.spt.y = Math.round(newPoint.y / snapUnit) * snapUnit;
    this.spt.update();

    if (this.closestLine != null) this.closestLine.highlight(false);
    this.closestLine = this.getClosestLine(this.childSiteList);

    if (this.closestLine != null) {
      this.closestLine.highlight(true);
    }
  }

  onMouseDown = (e: MouseEvent & TouchEvent) => {
    this.makeDot(e);
  }

  getClosestLine(sitelist: marietta.webcad.item.Site[]): marietta.webcad.item.parts.SiteLine {
    let minDistance: number = Number.MAX_VALUE;
    let tarLine: marietta.webcad.item.parts.SiteLine;
    let initalMouseX = 0; 
    let initalMouseY = 0;
    const mouse = new marietta.core.Point(this.tarLayer.spt.mouseX, this.tarLayer.spt.mouseY);
    for (let i = 0; i < sitelist.length; i += 1) {
      const allItemLineList = sitelist[i].lines;
      for (let j = 0; j < allItemLineList.length; j += 1) {
        initalMouseX = sitelist[i].itemInfo.x;
        initalMouseY = sitelist[i].itemInfo.y;
        const firstDot = new marietta.core.Point(allItemLineList[j].firstDot.x
          + initalMouseX, allItemLineList[j].firstDot.y + initalMouseY);
        const secondDot = new marietta.core.Point(allItemLineList[j].secondDot.x
          + initalMouseX, allItemLineList[j].secondDot.y + initalMouseY);
        if (allItemLineList[j].partnerRoad.roadwidth <= 0 && !allItemLineList[j].locked) {
          const distance = marietta.webcad.util.WebCADUtil.xGetClosestPointDistance(mouse as marietta.core.Point,
            firstDot as marietta.core.Point,
            secondDot as marietta.core.Point);
          if (distance <= minDistance) {
            minDistance = distance;
            tarLine = allItemLineList[j];
            tarLine.parent.itemInfo = sitelist[i].itemInfo;
          }
        }
      }
    }
    return tarLine;
  }

  followMouseHandler() {
    // e.preventDefault();
    const newPoint: marietta.core.Point = new marietta.core.Point(this.tarLayer.spt.mouseX, this.tarLayer.spt.mouseY);

    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.isSnap() === false) {
      marietta.webcad.WebCADGlobal.snapManager.hideAll();
      const snap = marietta.webcad.WebCADGlobal.snapManager.nearestSnap(this.snapList, newPoint.x, newPoint.y);
      this.isMousePlaceSnapped = (snap != null);
      if (snap) {
        newPoint.x = snap.point.x;
        newPoint.y = snap.point.y;
      }
    } else {
      // グリッド吸着中は吸着要素を使わない。途中でグリッド割が off に変わっても残らないよう倒しておく
      this.isMousePlaceSnapped = false;
      let snapUnit = marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
      if (this.type === 'site') snapUnit = 1; // 敷地の場合は、吸着なし
      newPoint.x = Math.round(newPoint.x / snapUnit) * snapUnit;
      newPoint.y = Math.round(newPoint.y / snapUnit) * snapUnit;
    }
    this.spt.x = newPoint.x;
    this.spt.y = newPoint.y;
    this.spt.update();

    // 最後のラインの伸び縮
    if (this.currentLine !== undefined) {
      if (this.currentLine.secondDot.distanceTo(newPoint) >= 1) {
        this.currentLine.secondDot = newPoint.clone();
        this.currentText.secondDot = newPoint.clone();
      }
    }

    // マウス場所保持
    this.mousePlace = newPoint.clone();
  }

  /**
   * マウス追従
   */
  followMouse = (e: MouseEvent & TouchEvent) => {
    let ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      e.preventDefault();
    }

    this.moveMouseEvent = e;
    // const self:ItemControllerBasePointInput = this;
    // pad スマホ用タッチ座標修正
    ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      if (e.touches.length >= 2) {
        // self.deleteMe();
        // self.onMouseUpMe(e);
        return;
      }
      e.preventDefault();
      Stage.refreshStageMouse(<any>e);
    }
  }

  /**
   * マウス追従終了
   */
  stopFollowMouse() {
    const stage = document.querySelector('#layerGroup');
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      stage.removeEventListener('touchmove', this.followMouse);
      stage.removeEventListener('touchstart', this.onMouseDown);
      stage.removeEventListener('touchstart', this.onClickBase);
    } else {
      stage.removeEventListener('mousemove', this.followMouse);
      stage.removeEventListener('mousedown', this.onMouseDown);
      stage.removeEventListener('mousedown', this.onClickBase);
      stage.removeEventListener('contextmenu', ItemControllerBasePointInput.contextMenu);
    }
    this.spt.deleteEnterFrame();
    this.moveMouseEvent = null;
    marietta.webcad.WebCADGlobal.snapManager.hideAll();
    if (document.getElementById('controller_snap_guide')) {
      document.getElementById('controller_snap_guide').remove();
    }
    // 入力完了ボタンの削除
    this.resetInputCompleted();
    // ペンの削除
    if (document.getElementById('controller_pen')) {
      document.getElementById('controller_pen').remove();
    }
  }

  /**
   * ドットの作成
   * @param MouseEvent
   */
  protected makeDot = (e: MouseEvent & TouchEvent) => {
    e.stopPropagation();
    if ((marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode === CONTROL_ACTIONMODE.ACTIONMODE_INPUT_POINT_SITE) && (e.button === 2)) return;

    // pad スマホ用タッチ座標修正
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      Stage.refreshStageMouse(<any>e);
    }

    if (!this.mousePlace) {
      // eslint-disable-next-line no-empty
      if ((ua.isMobile || ua.isTablet) && marietta.webcad.WebCADGlobal.webcad2Dmanager.isMansion() && this.dotList.length === 0) {

      } else {
        this.followMouse(e);
        return;
      }
    }
    let newPoint: marietta.core.Point;
    if (this.mousePlace) {
      newPoint = this.mousePlace.clone();
    }
    const time: Date = new Date();
    const nowTime: number = time.getTime();
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.isSnap() === false) {
      marietta.webcad.WebCADGlobal.snapManager.hideAll();
      // 追従中に決まった吸着位置をそのまま確定する。ここで吸着し直すと表示中の点とずれる
      let isSnapped: boolean = this.isMousePlaceSnapped;
      if (!this.mousePlace || this.isMousePlaceSnapped === null) {
        if (!this.mousePlace) newPoint = new marietta.core.Point(this.tarLayer.spt.mouseX, this.tarLayer.spt.mouseY);
        const snap = marietta.webcad.WebCADGlobal.snapManager.nearestSnap(this.snapList, newPoint.x, newPoint.y); // 最も近いスナップを取得する
        isSnapped = (snap != null);
        if (snap) {
          newPoint.x = snap.point.x;
          newPoint.y = snap.point.y;
        }
      }

      if (!isSnapped) {
        if (this.dotList.length > 0) {
          // ダミー線分を追加（スナップ用）
          marietta.webcad.WebCADGlobal.snapManager.addLineSegmentSnap(this.snapList, this.dotList[this.dotList.length - 1].x, this.dotList[this.dotList.length - 1].y, newPoint.x, newPoint.y, marietta.webcad.manager.SnapManager.SNAP_RADIUS, 10, null, 'dummy');
        }
        marietta.webcad.WebCADGlobal.snapManager.addPointSnap(this.snapList, newPoint.x, newPoint.y, marietta.webcad.manager.SnapManager.SNAP_RADIUS, 10, null, 'dummy');// ダミーポイントを追加（スナップ用）
      }
      marietta.webcad.WebCADGlobal.snapManager.lowerGuidePriority(this.snapList);// 直近以外のガイドの優先度を下げる

      let a; let b; let c;
      const snapPriority = this.hasRoomWallSnap ? marietta.webcad.manager.SnapManager.CURRENT_GUIDE_PRIORITY : 15;
      ({ a, b, c } = marietta.webcad.WebCADGlobal.snapManager.horizontalLine(newPoint.y));
      marietta.webcad.WebCADGlobal.snapManager.addLineSnap(this.snapList, a, b, c, marietta.webcad.manager.SnapManager.SNAP_RADIUS, snapPriority, null, true, true); // 水平線スナップを追加
      ({ a, b, c } = marietta.webcad.WebCADGlobal.snapManager.verticalLine(newPoint.x));
      marietta.webcad.WebCADGlobal.snapManager.addLineSnap(this.snapList, a, b, c, marietta.webcad.manager.SnapManager.SNAP_RADIUS, snapPriority, null, true, true); // 垂直線スナップを追加

      if (this.dotList.length === 0) {
        if (this.isPointOnWall) {
          if (this.isPointOnWall(newPoint)) this.isRoomWallSnap = true;
        }
      }
    }
    if ((marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode === CONTROL_ACTIONMODE.ACTIONMODE_INPUT_POINT_ROOM || marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode === CONTROL_ACTIONMODE.ACTIONMODE_INPUT_WALL)
      && marietta.webcad.WebCADGlobal.webcad2Dmanager.isMansion()) {
      // ダブルクリックもしくは、始点の近くであれば、作成終了
      const dotLimit = this.hasRoomWallSnap ? 1 : 2;
      if (this.dotList.length > dotLimit) {
        if (this.dotList[0].distanceTo(newPoint) < 10 || nowTime - this.lastTime < 300) {
          if (this.type !== 'wall') {
            if (this.dotList[0].distanceTo(newPoint) < 10) this.dotList.push(newPoint);
          }
          // ダブルクリックの場合は最後の点を削除
          this.endMakeShape();
          return;
        }

        // 最終点をもう一度、押していたら
        if (this.dotList[this.dotList.length - 1].distanceTo(newPoint) < 10) {
          this.endMakeShape();
          return;
        }
      }

      // 前のラインとテキストの位置
      if (this.currentLine !== undefined) {
        this.currentLine.secondDot = new marietta.core.Point(newPoint.x, newPoint.y);
        this.currentText.secondDot = this.currentLine.secondDot.clone();
      }

      // 頂点情報の保持
      this.dotList.push(newPoint);
      
      // 入力完了ボタンが押された
      if (this.isBtnInputCompleted) {
        this.endMakeShape();
        return;
      }

      if (this.dotList.length > 1 && this.isPointOnWall(newPoint) && this.type === 'wall') {
        this.endMakeShape();
      }
      // if (this.dotList.length > 1 && this.isPointOnWall(newPoint) && this.isRoomWallSnap && this.hasRoomWallSnap) {
      //   this.endMakeShape();
      // }

      // ドットの作成
      this.createDotImage(newPoint);

      // ラインの作成
      this.currentLine = new marietta.webcad.control.parts.StretchLineWall(this.dotImage, this.dotList.length);
      this.currentLine.firstDot = new marietta.core.Point(newPoint.x, newPoint.y);
      this.currentLine.secondDot = marietta.webcad.WebCADGlobal.userAgentManager.isPC ? new marietta.core.Point(this.mousePlace.x, this.mousePlace.y) : newPoint;

      // テキスト
      if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
        this.currentText = new marietta.webcad.control.parts.StrechLineText(this.dotImage, this.dotList.length);
        this.currentText.firstDot = newPoint;
        this.currentText.secondDot = new marietta.core.Point(this.spt.x, this.spt.y);
      } else {
        if (this.currentText) (this.currentText as marietta.webcad.control.parts.StretchLineWallText).switchToTextView();
        this.currentText = new marietta.webcad.control.parts.StretchLineWallText(this.dotImage, this.dotList.length);
        this.currentText.firstDot = new marietta.core.Point(newPoint.x, newPoint.y);
        this.currentText.secondDot = new marietta.core.Point(this.mousePlace.x, this.mousePlace.y);
        (this.currentText as marietta.webcad.control.parts.StretchLineWallText).updateLine = this.updateLineByTextInput;
      }
      // 最終クリック時間
      this.lastTime = nowTime;
    } else {
      // ダブルクリックもしくは、始点の近くであれば、作成終了
      if (this.dotList.length > 2) {
        if (newPoint.distanceTo(this.dotList[0]) < 10 || (nowTime - this.lastTime < 300)) {
          this.endMakeShape();
          return;
        }
      }

      // 前のライン類の終点指定
      if (this.currentLine !== undefined) {
        this.currentLine.secondDot = new marietta.core.Point(newPoint.x, newPoint.y);
        this.currentText.secondDot = this.currentLine.secondDot.clone();
      }

      if ((this.dotList.length > 1) && (nowTime - this.lastTime < 300) && marietta.webcad.WebCADGlobal.webcad2Dmanager.currentSiteEditMode === SITE_EDITMODE.SITE_EDIT_TRIANGULAR_INPUT) {
        return;
      }

      // 頂点情報の保持
      this.dotList.push(newPoint);
      
      // 入力完了ボタンが押された
      if (this.isBtnInputCompleted) {
        this.endMakeShape();
        return;
      }

      this.createDotImage(newPoint);

      // ラインの作成
      this.currentLine = new marietta.webcad.control.parts.StrechLine(this.dotImage, this.dotList.length);
      this.currentLine.firstDot = newPoint;
      if (ua.isPC) {
        this.currentLine.secondDot = new marietta.core.Point(this.spt.x, this.spt.y);
      } else {
        this.currentLine.secondDot = newPoint;
      }

      // テキスト
      this.currentText = new marietta.webcad.control.parts.StrechLineText(this.dotImage, this.dotList.length);
      this.currentText.firstDot = newPoint;
      this.currentText.secondDot = new marietta.core.Point(this.spt.x, this.spt.y);

      // 最終クリック時間
      this.lastTime = nowTime;
      if ((marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode === CONTROL_ACTIONMODE.ACTIONMODE_INPUT_POINT_SITE) && this.dotList.length === 3 && marietta.webcad.WebCADGlobal.webcad2Dmanager.currentSiteEditMode === SITE_EDITMODE.SITE_EDIT_TRIANGULAR_INPUT) {
        this.endMakeShape();
      }
    }
  }

  /**
  * 最後の入力点の削除
  */
  cancelPreviousDot() {
    if (this.dotList.length === 0) {
      this.endMakeShape();
    }
    // 最終ポイントを削除して、描画しなおす
    this.dotList.splice(this.dotList.length - 1, 1);

    // 中身を空にする
    this.dotImage.removeChildren();
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.isSnap() === false) {
      this.resetSnapElements();
    }
    // 描画しなおす
    this.currentLine = undefined;
    this.currentText = undefined;
    for (let i: number = 0; i < this.dotList.length; i += 1) {
      this.makeDotAt(this.dotList[i]);
    }
  }

  /**
    * ドットの作成
    * @param MouseEvent
    */
  makeDotAt(newPoint: marietta.core.Point) {
    console.log(newPoint);
    // 前のライン類の終点指定
    if (this.currentLine !== undefined) {
      this.currentLine.secondDot = new marietta.core.Point(newPoint.x, newPoint.y);
      this.currentText.secondDot = new marietta.core.Point(newPoint.x, newPoint.y);
    }

    this.createDotImage(newPoint);

    // ラインの作成
    this.currentLine = new marietta.webcad.control.parts.StrechLine(this.dotImage, this.dotList.length);
    this.currentLine.firstDot = new marietta.core.Point(newPoint.x, newPoint.y);
    this.currentLine.secondDot = marietta.webcad.WebCADGlobal.userAgentManager.isPC ? new marietta.core.Point(this.mousePlace.x, this.mousePlace.y) : new marietta.core.Point(newPoint.x, newPoint.y);

    // テキスト
    this.currentText = new marietta.webcad.control.parts.StrechLineText(this.dotImage, this.dotList.length);
    this.currentText.firstDot = newPoint;
    this.currentText.secondDot = new marietta.core.Point(this.spt.x, this.spt.y);
  }

  /**
    * スナップ要素をリセット
    */
  resetSnapElements() {
    this.snapList = [];
    this.snapList = marietta.webcad.WebCADGlobal.snapManager.snapElements.map((m: SnapElemnt) => m);// スナップ要素を更新して取得する
    for (let i = 0; i < this.dotList.length; i += 1) {
      if (i < this.dotList.length - 1) {
        // ダミー線分を追加（スナップ用）
        marietta.webcad.WebCADGlobal.snapManager.addLineSegmentSnap(this.snapList, this.dotList[i].x, this.dotList[i].y, this.dotList[i + 1].x, this.dotList[i + 1].y, marietta.webcad.manager.SnapManager.SNAP_RADIUS, 10, null, 'dummy');
      }
      marietta.webcad.WebCADGlobal.snapManager.addPointSnap(this.snapList, this.dotList[i].x, this.dotList[i].y, marietta.webcad.manager.SnapManager.SNAP_RADIUS, 10, null, 'dummy');// ダミーポイントを追加（スナップ用）
      let a; let b; let c;
      ({ a, b, c } = marietta.webcad.WebCADGlobal.snapManager.horizontalLine(this.dotList[i].y));
      (i === this.dotList.length - 1) ? marietta.webcad.WebCADGlobal.snapManager.addLineSnap(this.snapList, a, b, c, marietta.webcad.manager.SnapManager.SNAP_RADIUS, marietta.webcad.manager.SnapManager.CURRENT_GUIDE_PRIORITY, null, true) : marietta.webcad.WebCADGlobal.snapManager.addLineSnap(this.snapList, a, b, c, marietta.webcad.manager.SnapManager.SNAP_RADIUS, marietta.webcad.manager.SnapManager.PAST_GUIDE_PRIORITY, null, true); // 水平線スナップを追加
      ({ a, b, c } = marietta.webcad.WebCADGlobal.snapManager.verticalLine(this.dotList[i].x));
      (i === this.dotList.length - 1) ? marietta.webcad.WebCADGlobal.snapManager.addLineSnap(this.snapList, a, b, c, marietta.webcad.manager.SnapManager.SNAP_RADIUS, marietta.webcad.manager.SnapManager.CURRENT_GUIDE_PRIORITY, null, true) : marietta.webcad.WebCADGlobal.snapManager.addLineSnap(this.snapList, a, b, c, marietta.webcad.manager.SnapManager.SNAP_RADIUS, marietta.webcad.manager.SnapManager.PAST_GUIDE_PRIORITY, null, true); // 垂直線スナップを追加
    }
  }

  onClickBase = (e: MouseEvent) => {
    e.stopPropagation();
    if (e.button === 2) return;
    if (this.closestLine === null) return;

    const time: Date = new Date();
    const nowTime: number = time.getTime();
    let newPoint: marietta.core.Point = new marietta.core.Point(this.closestLine.firstDot.x + this.closestLine.parent.itemInfo.x, this.closestLine.firstDot.y + this.closestLine.parent.itemInfo.y);
    this.dotList.push(newPoint);
    newPoint = new marietta.core.Point(this.closestLine.secondDot.x + this.closestLine.parent.itemInfo.x, this.closestLine.secondDot.y + this.closestLine.parent.itemInfo.y);
    this.dotList.push(newPoint);
    // 頂点の作成
    this.createDotImage(newPoint);
    // ラインの作成
    this.currentLine = new marietta.webcad.control.parts.StrechLine(this.dotImage, this.dotList.length);
    this.currentLine.firstDot = newPoint;
    this.currentLine.secondDot = newPoint;
    // テキスト
    this.currentText = new marietta.webcad.control.parts.StrechLineText(this.dotImage, this.dotList.length);
    this.currentText.firstDot = newPoint;
    this.currentText.secondDot = new marietta.core.Point(this.spt.x, this.spt.y);
    // 最終クリック時間
    this.lastTime = nowTime;
    const stage = document.querySelector('#layerGroup');
    if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
      stage.removeEventListener('touchstart', this.onClickBase);
      stage.addEventListener('touchstart', this.onMouseDown);
    } else {
      stage.removeEventListener('mousedown', this.onClickBase);
      stage.addEventListener('mousedown', this.onMouseDown);
    }
    this.isSelectBaseEvent = false;
  }

  /**
   * 形状作成の終了
   */
  endMakeShape() {
    // マウスの追従終了
    this.stopFollowMouse();
    if (this.closestLine) this.closestLine.highlight(false);
    // 面積ゼロならアイテムを作成しない
    if (marietta.webcad.util.WebCADUtil.calculateArea(this.dotList) > 0) {
      // アイテム情報の作成
      let dot: marietta.webcad.collection.PointCollection;
      const info: marietta.webcad.collection.ItemInfoCollection = new marietta.webcad.collection.ItemInfoCollection();
      info.x = this.dotList[0].x;
      info.y = this.dotList[0].y;
      info.id = 'rom01_01';
      info.guid = marietta.webcad.WebCADGlobal.getGuid();
      if (this.type === 'site') {
        info.id = 'sit01_01';
      } else if (this.type === 'roof') {
        info.id = 'rof01_01';
      } else {
        // 現在選択されている部屋種類の取得

        // アイテムメニューUI変更のため、仕様変更 20160601 森本 start
        info.id = String((<HTMLInputElement>document.getElementById('roomInputMenuItems').querySelector('input[type="radio"]:checked')).value);
        // アイテムメニューUI変更のため、仕様変更 20160601 森本 end
      }
      info.dotList = [];

      const defaultRoomSetting = marietta.webcad.WebCADGlobal.getRoomConfig(info.id);
      if ((info.id === 'col01_01' || info.id === 'bem01_01') && this.dotList[this.dotList.length - 1].distanceTo(this.dotList[0]) === 0) {
        this.dotList.splice((this.dotList.length - 1), 1);
        if (marietta.webcad.util.WebCADUtil.isClockwise(this.dotList)) {
          this.dotList = <marietta.core.Point[]>marietta.webcad.util.WebCADUtil.sortListCounterClockwise(this.dotList);
        }
      }
      for (let i: number = 0; i < this.dotList.length; i += 1) {
        dot = new marietta.webcad.collection.PointCollection(this.dotList[i].x - info.x, this.dotList[i].y - info.y, defaultRoomSetting.wallType);
        dot.guid = marietta.webcad.WebCADGlobal.getGuid();
        info.dotList.push(dot);
      }
      if (info.id === 'bem01_01') info.height = 300;
      // 作成
      const item = marietta.webcad.WebCADGlobal.itemManager.createItem(info);
      // 部屋面積ほぼゼロチェック
      if (marietta.webcad.util.WebCADUtil.isAreaZero(info.dotList)) {
        item.deleteMe();
      }
      marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();

      //見積リスト更新
      marietta.webcad.WebCADGlobal.quotationItemList.createData();

    }
    this.dotList = [];
    // 作成用モジュールなど削除する
    this.viewObj.remove();
    this.dotImage.remove();
    if (this.callbackOnComplete) {
      this.callbackOnComplete();
    }
  }

  /**
     * ドットの作成
     */
  protected createDotImage = (newPoint: marietta.core.Point): void => {
    // 頂点の作成
    const _dot: SVGElement = document.createElementNS('http://www.w3.org/2000/svg', 'ellipse');
    (<SVGElement>_dot).setAttribute('cx', '0');
    (<SVGElement>_dot).setAttribute('cy', '0');
    (<SVGElement>_dot).setAttribute('rx', '5');
    (<SVGElement>_dot).setAttribute('fill', '#8a8a8a');
    (<SVGElement>_dot).setAttribute('id', `dot${this.dotList.length}`);
    const dot: SVGSprite = new SVGSprite(_dot);

    // ドットイメージの作成
    this.dotImage.addChild(dot);
    dot.x = newPoint.x;
    dot.y = newPoint.y;
    dot.update();
  }

  /**
   * HTMLElementの取得
   */
  public get viewObj(): HTMLElement {
    return this.spt.element;
  }

  /**
   * ピッカーのサイズ更新
   */
  public updatePickers(): void {
    const root: SVGSprite = marietta.webcad.WebCADGlobal.layerGroup.spt;
    const sc: number = 1 / root.scaleX;
    this.spt.scaleX = sc;
    this.spt.scaleY = sc;
    this.spt.update();
  }

  /**
   * 囲み入力の中断
   */
  interrupt() {
    // マウスの追従終了
    this.stopFollowMouse();
    // 作成用モジュールなど削除する
    this.viewObj.remove();
    this.dotImage.remove();
  }

  /**
   * 入力完了ボタンで入力を完了させる
   */
  private InputCompleted = (e: MouseEvent & TouchEvent) => {
    e.preventDefault();
    e.stopPropagation();
    this.isBtnInputCompleted = true;
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      this.makeDot(e);
    } else {
      this.endMakeShape();
    }
  }

  /**
   * カーソルを隠す
   */
  private hideCursor = (): void => {
    document.getElementById('controller_pen').style.display = 'none';
  }

  /**
   * カーソルを表示する
   */
  private showCursor = (): void => {
    document.getElementById('controller_pen').style.display = 'block';
  }

  /**
   * 入力完了ボタンの追加
   */
  private addInputCompleted(): void {
    // 戸建て 構造体：壁の時はボタンを表示しない
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode === CONTROL_ACTIONMODE.ACTIONMODE_INPUT_TOUCH_MOBILE) return;
    // 三斜入力時はボタンを表示しない
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentSiteEditMode === SITE_EDITMODE.SITE_EDIT_TRIANGULAR_INPUT) return;    
    document.getElementById('btnInputCompleted').style.display = 'block';
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      document.getElementById('btnInputCompleted').addEventListener('touchstart', this.InputCompleted);
    } else {
      document.getElementById('btnInputCompleted').addEventListener('mousedown', this.InputCompleted);
      document.getElementById('btnInputCompleted').addEventListener('mousemove', this.hideCursor);
      document.getElementById('btnInputCompleted').addEventListener('mouseout', this.showCursor);
    }
  }

  /**
   * 入力完了ボタンのイベントリセット
   */
  private resetInputCompleted(): void {
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      document.getElementById('btnInputCompleted').removeEventListener('touchstart', this.InputCompleted);
    } else {
      document.getElementById('btnInputCompleted').removeEventListener('mousedown', this.InputCompleted);
      document.getElementById('btnInputCompleted').removeEventListener('mousemove', this.hideCursor);
      document.getElementById('btnInputCompleted').removeEventListener('mouseout', this.showCursor);
    }
    document.getElementById('btnInputCompleted').style.display = 'none';
  }

}
export default ItemControllerBasePointInput;
